import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selectOverlayState = (state: RootState) => state.overlay.overlay;
export const selectIsBoardLocked = (state: RootState) => state.overlay.overlay.isBoardLocked;
export const selectIsHideControlPanel = (state: RootState) => state.overlay.overlay.isHideControlPanel;
export const selectEvents = createSelector([selectOverlayState], (state) => state.events);
export const selectActiveEventId = createSelector([selectOverlayState], (state) => state.activeEventId);
export const selectPopup = createSelector([selectOverlayState], (state) => state.popup);
export const selectPopupIsLoaded = createSelector([selectOverlayState], (state) => state.popupIsLoaded);
